import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ui-button',
  props: {
  /**
   * Высота кнопки
   */
  height: {
    type: String,
    default: "48",
  },
  /**
   * Включена ли валидация
   */
  minWidth: {
    type: String,
    default: "100%",
  },
  /**
   * Включена ли валидация
   */
  color: {
    type: String,
    default: "var(--main-color)",
  },
  /**
   * Состояние загрузки
   */
  loading: {
    type: Boolean,
    default: false,
  },
  /**
   * Иконка слева
   */
  prependIcon: {
    type: String,
  },
  /**
   * Тип кнопки
   */
  variant: {
    type: String,
  },
  /**
   * Тип кнопки
   */
  size: {
    type: String,
    default: "large",
  },
},
  emits: ["click"],
  setup(__props, { emit }) {

const props = __props;



/**
 * События
 */


onMounted(async () => { });

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    height: __props.height,
    "min-width": __props.minWidth,
    loading: __props.loading,
    "prepend-icon": __props.prependIcon,
    class: "ui-button text-none",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click'))),
    color: __props.color,
    size: __props.size
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["height", "min-width", "loading", "prepend-icon", "color", "size"]))
}
}

})